<script lang="ts">
  import { beforeNavigate, goto } from "$app/navigation";
  import { page } from "$app/state";

  import { isRouteUnder } from "$lib/core/route-id";
  import { requiresPhoneVerification } from "$lib/identity/phone-verification";
  import { user } from "$lib/identity/user";

  // Dashboard layouts and the phone verification page return the flag when it is on.
  const verificationRequired = $derived(
    requiresPhoneVerification(
      $user,
      page.data.signupPhoneVerificationFlag === true,
    ),
  );

  function goToVerification() {
    void goto("/phone-verification", { replaceState: true });
  }

  beforeNavigate(({ to, cancel }) => {
    if (verificationRequired && isRouteUnder(to?.route.id, "/(dash)")) {
      cancel();
      if (page.route.id !== "/(auth)/phone-verification") {
        goToVerification();
      }
    }
  });

  $effect(() => {
    if (verificationRequired && isRouteUnder(page.route.id, "/(dash)")) {
      goToVerification();
    }
  });
</script>
